import { createAsyncThunk } from '@reduxjs/toolkit';
import { permissionsApi } from 'container/permissionsApi';
import { serializeError } from 'shared/utils/redux';

import { STORE_NAME } from './initialState';

export const fetchPermissions = createAsyncThunk(
  `${STORE_NAME}/fetchPermissions`,
  ({ projectId }: { projectId: number }) => {
    return permissionsApi.get(projectId);
  },
  { serializeError },
);

export const fetchPermissionGroups = createAsyncThunk(
  `${STORE_NAME}/fetchPermissionGroups`,
  ({ projectId }: { projectId: number }) => {
    return permissionsApi.getPermissionGroups(projectId);
  },
  { serializeError },
);

export const fetchPermissionFlags = createAsyncThunk(
  `${STORE_NAME}/fetchPermissionFlags`,
  () => {
    return permissionsApi.getFlags();
  },
  { serializeError },
);
